/**
 * Resolve the PlayCanvas gsplat URL from world.json `splat`.
 *
 * Streamed (default for legacy `.sog` paths): `sogs-lod/<stem>/lod-meta.json` octree.
 * Monolithic (`splatStreaming: false`): pass `.sog` through unchanged.
 */
export function isStreamedSplatUrl(url: string): boolean {
  return /\/lod-meta\.json(?:[?#].*)?$/i.test(url);
}

export function resolvePlayCanvasSplatUrl(
  splat: string,
  legacyOverride?: string,
  options?: { streaming?: boolean; mobile?: boolean; mobileSplat?: string },
): string {
  if (options?.mobile && options.mobileSplat && options.mobileSplat.length > 0) {
    return options.mobileSplat;
  }

  if (legacyOverride && legacyOverride.length > 0) {
    return legacyOverride;
  }

  if (/\/lod-meta\.json(?:[?#].*)?$/i.test(splat)) {
    return splat;
  }

  const wantsMonolithic = options?.streaming === false;
  if (wantsMonolithic && /\.sog(?:[?#].*)?$/i.test(splat)) {
    return splat;
  }

  const radMatch = splat.match(/\/([^/]+)-lod\.rad(?:[?#].*)?$/i);
  if (radMatch) {
    const stem = radMatch[1];
    if (splat.startsWith('http')) {
      try {
        const origin = new URL(splat).origin;
        return `${origin}/sogs-lod/${stem}/lod-meta.json`;
      } catch {
        // fall through
      }
    }
    return `/sogs-lod/${stem}/lod-meta.json`;
  }

  const sogMatch = splat.match(/\/([^/]+)\.sog(?:[?#].*)?$/i);
  if (sogMatch) {
    return `/sogs-lod/${sogMatch[1]}/lod-meta.json`;
  }

  return splat;
}
